import { useEffect, useState } from 'react'
import contractTypeMasterService from '../../services/contractTypeMasterService'

export const DEFAULT_CONTRACT_TYPES = [
  'Service Agreement',
  'NDA',
  'MSA',
  'SOW',
  'Purchase Order',
  'License Agreement',
  'Partnership Agreement',
  'Other'
]

// Active Contract Type Master names, falling back to the built-in list when the master is empty.
// The current value is always kept selectable so older/inactive types still display on edit.
export const useContractTypeOptions = (currentValue) => {
  const [types, setTypes] = useState(DEFAULT_CONTRACT_TYPES)
  const [fromMaster, setFromMaster] = useState(false)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        const response = await contractTypeMasterService.getAllContractTypes({ status: 'Active', limit: 500 })
        const names = (response?.success ? response.data || [] : [])
          .map((t) => (t.contractTypeName || '').trim())
          .filter(Boolean)
        if (!cancelled && names.length > 0) {
          setTypes(Array.from(new Set(names)))
          setFromMaster(true)
        }
      } catch (error) {
        console.error('Error loading contract types:', error)
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  const options = currentValue && !types.includes(currentValue) ? [currentValue, ...types] : types
  return { options, fromMaster }
}
